module.exports = __webpack_public_path__ + "DOCX.png";